var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"login",on:{"click":_vm.logout}},[_vm._v("\n        退出\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }